import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useStore from "../../context/useStore";
import dataService from "../../helpers/dataService";

var searchTimeout = "";

const useApiDatas = ({
  /////////////////////////////////////
  //POUR RECUPERER UNE LISTE SEARCH
  /////////////////////////////////////
  resourcePath = false, //url de la resource pour le search et le delete ex : productionsites
  searchParams = {}, //state du search item: {searchString:"",page:1}
  formatSearchDatasFn = false, //fonction à appeler sur les datas reçues du search
  /////////////////////////////////////
  //POUR CRUD SUR UN ITEM
  /////////////////////////////////////
  itemPaths = false, // {path:"",get:"",post:"",patch:""} url du crud sur item
  itemId = false, //passer props.match.params.id
  itemParams = {}, //state de l'item {name: "", code:"", ...}
  formatItemDatasFn = false, //fonction à appeler sur les datas reçues pour l'item
  /////////////////////////////////////
  //POUR RECUPERER LES DEPENDANCES
  /////////////////////////////////////
  dependenciesPath = [], //array de strings ex : productionsites
  /////////////////////////////////////
}) => {
  const [isInit, setIsInit] = useState(false);
  const isEdit = itemId == "create" ? false : true;
  const [state, dispatch] = useStore();
  const constants = state.constants.items;
  const [errors, setErrors] = useState({});
  const [searchDatas, setSearchDatas] = useState([]);
  const [searchDatasFinish, setSearchDatasFinish] = useState(
    resourcePath ? false : true
  );
  const [getItemFinish, setGetItemFinish] = useState(
    itemId && isEdit ? false : true
  );
  const [otherDatas, setOtherDatas] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [nbPages, setNbPages] = useState(1);
  const [search, setSearch] = useState(searchParams);
  const [item, setItem] = useState(itemParams);

  useEffect(() => {
    if (itemId && isEdit) {
      getItem();
    }
    if (resourcePath) {
      getSearchDatas();
    }
    if (dependenciesPath.length) {
      getAllDependencies();
    }
  }, []);

  useEffect(() => {
    if (isInit) {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        getSearchDatas();
      }, 1500);
    }
  }, [search]);

  useEffect(() => {
    if (isLoading) setErrors({});
  }, [isLoading]);

  useEffect(() => {
    if (
      Object.keys(otherDatas).length == dependenciesPath.length &&
      searchDatasFinish &&
      getItemFinish
    ) {
      setIsInit(true);
    }
  }, [otherDatas, searchDatasFinish, getItemFinish]);

  const getSearchDatas = (path = false, postData = false) => {
    setIsLoading(true);
    dataService.post(
      path || resourcePath + "/search",
      postData || search,
      (datas) => {
        setSearchDatas(
          formatSearchDatasFn ? formatSearchDatasFn(datas.datas) : datas.datas
        );
        setSearchDatasFinish(true);
      },
      setErrors,
      () => {
        setIsLoading(false);
      }
    );
  };
  const getItem = (path = false) => {
    setIsLoading(true);
    dataService.get(
      path || itemPaths.get,
      (datas) => {
        setItem(formatItemDatasFn ? formatItemDatasFn(datas) : datas);
        setGetItemFinish(true);
      },
      setErrors,
      () => {
        setIsLoading(false);
      }
    );
  };

  const getAllDependencies = async () => {
    var deps = {};
    for (var key in dependenciesPath) {
      let dependency = dependenciesPath[key];
      deps[dependency] = await getDependency(dependency);
    }

    setOtherDatas(deps);
  };

  const getDependency = (dependencyPath) => {
    return new Promise((resolve, reject) => {
      dataService.get(
        dependencyPath,
        (datas) => {
          resolve(datas);
        },
        (error) => reject(error),
        () => {}
      );
    });
  };
  const deleteData = (id, path = false) => {
    dataService.remove(
      path || resourcePath + "/" + id,
      {},
      (datas) => getSearchDatas(),
      setErrors,
      () => setIsLoading(false)
    );
  };

  const saveItem = () => {
    if (isEdit) {
      patchItem();
    } else {
      postItem();
    }
  };

  const postItem = (path = false, postData = false, shouldRedirect = true) => {
    setIsLoading(true);
    dataService.post(
      path || itemPaths.post,
      postData || item,
      (datas) => {
        toast.success("Entrée créée avec succès");
        if (shouldRedirect) {
          window.location.href = itemPaths.path + datas.id;
        }
      },
      setErrors,
      () => setIsLoading(false)
    );
  };

  const patchItem = (path = false, patchData = false) => {
    setIsLoading(true);
    dataService.patch(
      path || itemPaths.patch,
      patchData || item,
      (datas) => {
        setItem({
          ...item,
          createdAt: datas.createdAt,
          updatedAt: datas.updatedAt,
        });
        toast.success("Entrée enregistré avec succès");
      },
      setErrors,
      () => setIsLoading(false)
    );
  };

  return {
    state, //state global
    constants, //constantes
    errors, //erreurs ex : {name:"valeur requise"}
    setErrors, //set les erreurs
    isLoading, //chargement en cours
    setIsLoading, //set le chargement
    getSearchDatas, //lancer la requête SEARC
    search, //objet du state SEARCH
    setSearch, //set l'objet du state SEARCH
    searchDatas, //datas issues du SEARCH
    setSearchDatas, //set les datas issues du SEARCH
    nbPages, //nombre de pages du SEARCH
    setNbPages, //set le nombre de pages du SEARCH
    deleteData, //DELETE un item en passant son id
    isInit, //true quand tout est chargé (datas + dépendances)
    otherDatas, //dépendances { dependance1: <datas>, dependance2: <datas>, ... }
    setOtherDatas, //set les dépendances
    itemId, //id de l'item create ou id
    isEdit, //true si id de l'item présent
    item, //objet du state de l'item
    setItem, //set l'objet du state de l'item
    saveItem, //post ou patch l'item
  };
};

export default useApiDatas;
